module.exports = __webpack_public_path__ + "media/images/icon/icons8-Horizontal Settings Mixer-e6a3f885055aa00572a7d1e40a5518fc.png";